export const applyCalculatedFields = (row, computedFields = {}) => {
  const updatedRow = { ...row };

  Object.entries(computedFields).forEach(([targetField, config]) => {
    const { expression, type = "number" } = config;

    if (!expression) return;

    try {
      let formula = expression;

      // Replace [COLUMN_NAME] with value
      formula = formula.replace(/\[([^\]]+)\]/g, (_, fieldName) => {
        const value = updatedRow[fieldName];

        if (value === undefined || value === null || value === "") {
          return 0;
        }

        return Number(value);
      });

      let result = Function(`"use strict"; return (${formula})`)();

      if (type === "number") {
        result = Number(result || 0);
      }

      updatedRow[targetField] = result;
    } catch (error) {
      console.error(`Error calculating ${targetField}`, error);

      updatedRow[targetField] = "";
    }
  });

  return updatedRow;
};
